'use client';

import ErrorPage from '@local/common/ui/components/error/ErrorPage';
import errorCode from 'http-status';

export default function Error() {
    return <ErrorPage statusCode={errorCode.INTERNAL_SERVER_ERROR} />;
}
